import React, { useEffect } from 'react'
import Modal from 'react-responsive-modal'
import { useDispatch, useSelector } from 'react-redux'
import styles from './styles.module.css'
import { useFormik } from 'formik'
import { Input, Select, Checkbox } from '../../../../components/ModalInputs'
import ModalFooter from '../../../../components/ModalFooter/ModalFooter'
import { getLibraryFamilyEthnicities } from '../../../../actions/library'
import CustomSelect from '../../../../components/CustomSelect'
import { arrayForSelect } from '../../../../utils/arrayForSelect'

const relationshipOptions = [
  'Отец', 'Мать', 'Брат', 'Сестра', 'Бабушка', 'Дедушка',
  'Отчим', 'Мачеха', 'Тётя', 'Дядя', 'Муж', 'Жена',
  'Сын', 'Дочь', 'Внук', 'Внучка', 'Пасынок', 'Падчерица',
  'Тесть', 'Тёща', 'Свекор', 'Свекровь', 'Зять', 'Невестка (сноха)',
  'Опекун', 'Другая степень родства, свойства',
]

const documentTypeOptions = [
  { value: 'Паспорт', name: 'Паспорт' },
  { value: 'Иной документ', name: 'Иной документ' },
]

const educationLvlOptions = [
  { value: '', name: '' },
  { value: 1, name: 'Высшее' },
  { value: 2, name: 'Среднее профессиональное' },
  { value: 3, name: 'Среднее общее' },
  { value: 4, name: 'Основное общее' },
]

export default function FamilyModal({ data, closeModal, height, addMode, onSave }) {
  const dispatch = useDispatch()
  const { familyEthnicities } = useSelector(state => state.library)

  useEffect(() => {
    if (!familyEthnicities?.length) dispatch(getLibraryFamilyEthnicities())
  }, []) // eslint-disable-line

  const { values, handleChange, handleSubmit, setFieldValue } = useFormik({
    initialValues: data || {},
    enableReinitialize: true,
    onSubmit: (vals) => {
      if (onSave) onSave(vals)
    }
  })

  const setVal = (name, value) => setFieldValue(name, value)

  return (
    <Modal
      open={!!data}
      onClose={() => false}
      showCloseIcon={false}
      center
      classNames={{ modal: styles.custom }}
    >
      <div className={styles.modalLocal}>
        <h3 className={styles.title}>Член семьи</h3>
        <div className={styles.tabWrapper}>
          <div className={styles.inputsColomn}>
            <Input
              label='Фамилия'
              name='lastname'
              value={values.lastname || ''}
              onChange={handleChange}
            />
            <Input
              label='Имя'
              name='firstname'
              value={values.firstname || ''}
              onChange={handleChange}
            />
            <Input
              label='Отчество'
              name='patronymic'
              value={values.patronymic || ''}
              onChange={handleChange}
            />
            <Select
              label='Тип родства'
              name='relationship'
              value={values.relationship || ''}
              onChange={handleChange}
            >
              <option value=''>—</option>
              {relationshipOptions.map(r => (
                <option key={r} value={r}>{r}</option>
              ))}
            </Select>
            <Input
              label='Дата рождения'
              type='date'
              name='birthday'
              value={values.birthday || ''}
              onChange={handleChange}
            />
            <Input
              label='Мобильный телефон'
              name='cellular'
              value={values.cellular || ''}
              onChange={handleChange}
            />
            <Input
              label='Место работы'
              name='workplace'
              value={values.workplace || ''}
              onChange={handleChange}
            />
            <CustomSelect
              title='Национальность'
              valuesName='ethnicity'
              value={values.ethnicity || ''}
              options={(familyEthnicities || []).map(e => ({ label: e.name || e, value: e.name || e }))}
              setFieldValue={setVal}
            />
            <Select
              label='Тип документа'
              name='documenttype'
              value={values.documenttype || ''}
              onChange={handleChange}
            >
              <option value=''>—</option>
              {documentTypeOptions.map(d => (
                <option key={d.value} value={d.value}>{d.name}</option>
              ))}
            </Select>
            <Input
              label='Серия документа'
              name='documentseria'
              value={values.documentseria || ''}
              onChange={handleChange}
            />
            <Input
              label='Номер документа'
              name='documentnumber'
              value={values.documentnumber || ''}
              onChange={handleChange}
            />
            <CustomSelect
              title='Уровень образования'
              valuesName='educationlvl'
              value={values.educationlvl || ''}
              options={arrayForSelect(educationLvlOptions, 'name', 'value')}
              setFieldValue={setVal}
            />
            <Checkbox
              label='Законный представитель'
              name='legalrepresentative'
              checked={values.legalrepresentative === -1}
              onChange={(e) => setFieldValue('legalrepresentative', e.target.checked ? -1 : 0)}
            />
            <Input
              label='Комментарии'
              name='comments'
              value={values.comments || ''}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>
      <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} />
    </Modal>
  )
}
